import { render, staticRenderFns } from "./ta-config-dialog.vue?vue&type=template&id=2805877f&scoped=true"
import script from "./ta-config-dialog.vue?vue&type=script&lang=js"
export * from "./ta-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./ta-config-dialog.vue?vue&type=style&index=0&id=2805877f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805877f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2805877f')) {
      api.createRecord('2805877f', component.options)
    } else {
      api.reload('2805877f', component.options)
    }
    module.hot.accept("./ta-config-dialog.vue?vue&type=template&id=2805877f&scoped=true", function () {
      api.rerender('2805877f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overview/ta-config-dialog.vue"
export default component.exports